import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { PRICING_PROFILE_DATE_RANGE_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { tzNormalizeDate } from '../../../../utils/date';
import EditPricingProfileDateRangeForm from './EditPricingProfileDateRangeForm';
import {
  clearPricingProfileDateRange,
  getPricingProfileDateRange,
  putPricingProfileDateRange,
} from '../../../../actions/sales/PricingProfileDateRange';

const EditPricingProfileDateRange = ({
  breadcrumbs,
  dispatchClearPricingProfileDateRange,
  dispatchGetPricingProfileDateRange,
  dispatchPutPricingProfileDateRange,
  match: {
    params: { id: pricingProfileDateRangeId },
  },
  loading,
  pricingProfileDateRange,
}) => {
  useLayoutEffect(() => {
    dispatchGetPricingProfileDateRange({ pricingProfileDateRangeId });

    return () => dispatchClearPricingProfileDateRange();
  }, []);

  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      startDate: formValues.startDate
        ? tzNormalizeDate({ date: formValues.startDate })
        : null,
      endDate: formValues.endDate
        ? tzNormalizeDate({ date: formValues.endDate })
        : null,
    };

    dispatchPutPricingProfileDateRange(
      pricingProfileDateRangeId,
      newFormValues,
    );
  };

  const generateInitialValues = (pricingProfileDateRangeJson) => ({
    year: pricingProfileDateRangeJson.year,
    startDate:
      pricingProfileDateRangeJson.startDate &&
      tzNormalizeDate({ date: pricingProfileDateRangeJson.startDate }),
    endDate:
      pricingProfileDateRangeJson.endDate &&
      tzNormalizeDate({ date: pricingProfileDateRangeJson.endDate }),
    reason: pricingProfileDateRangeJson.reason || '',
    corporate: !!pricingProfileDateRangeJson.corporate,
  });

  let content;

  if (loading) content = <Loader />;
  else if (pricingProfileDateRange.isEmpty())
    content = <NoDataResource returnPage={PRICING_PROFILE_DATE_RANGE_PATH} />;
  else
    content = (
      <EditPricingProfileDateRangeForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(pricingProfileDateRange.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Rango de Fechas"
      subtitle="Editar rango de fechas para perfiles de precio"
      content={content}
    />
  );
};

EditPricingProfileDateRange.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPricingProfileDateRange: PropTypes.func.isRequired,
  dispatchGetPricingProfileDateRange: PropTypes.func.isRequired,
  dispatchPutPricingProfileDateRange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  pricingProfileDateRange: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditPricingProfileDateRange.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPricingProfileDateRange: clearPricingProfileDateRange,
  dispatchGetPricingProfileDateRange: getPricingProfileDateRange,
  dispatchPutPricingProfileDateRange: putPricingProfileDateRange,
};

const mapStateToProps = (
  { SalesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Rango de Fechas para Perfiles de Precio',
      href: PRICING_PROFILE_DATE_RANGE_PATH,
    },
    {
      text: 'Ver',
      href: `${PRICING_PROFILE_DATE_RANGE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  pricingProfileDateRange: SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditPricingProfileDateRange);
